import { createClient, SupabaseClient, RealtimeChannel } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

class SupabaseService {
  private client: SupabaseClient | null = null;
  private channels: Map<string, RealtimeChannel> = new Map();

  initialize(): SupabaseClient {
    if (!this.client) {
      if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
        console.warn('Supabase credentials not configured');
        throw new Error('Supabase not configured');
      }
      this.client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
        realtime: {
          params: {
            eventsPerSecond: 10
          }
        }
      });
    }
    return this.client;
  }

  getClient(): SupabaseClient {
    if (!this.client) {
      return this.initialize();
    }
    return this.client;
  }

  createChannel(channelName: string): RealtimeChannel {
    const client = this.getClient();
    const channel = client.channel(channelName);
    this.channels.set(channelName, channel);
    return channel;
  }

  getChannel(channelName: string): RealtimeChannel | undefined {
    return this.channels.get(channelName);
  }

  async removeChannel(channelName: string): Promise<void> {
    const channel = this.channels.get(channelName);
    if (channel) {
      await channel.unsubscribe();
      this.channels.delete(channelName);
    }
  }

  async removeAllChannels(): Promise<void> {
    const promises = Array.from(this.channels.keys()).map(name => 
      this.removeChannel(name)
    );
    await Promise.all(promises);
  }
}

export const supabaseService = new SupabaseService();
